import { render, staticRenderFns } from "./cmpAIScore.vue?vue&type=template&id=5a2878a2&"
import script from "./cmpAIScore.vue?vue&type=script&lang=js&"
export * from "./cmpAIScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports